import { Helmet } from 'react-helmet';
import Navbar from '../components/universal/navbar';
import Header from '../components/terms-of-use/hero';
import PP from '../components/terms-of-use/content';
import Contact from '../components/universal/contactUs';
import Footer from '../components/universal/footer';


function Index() {
    return (
        <div>
            <Helmet>
                <link rel='canonical' href='https://www.alignar.com/terms-of-use' />
            </Helmet>
            <Navbar />
            <Header />
            <PP />
            <Contact />
            <Footer />
        </div>
    );
}

export default Index;